var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProximityCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 92,
    viewBox: "0 0 70 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8510_10912)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.90836,
    y: 0.532383,
    width: 51.0657,
    height: 82.089,
    rx: 3.64227,
    fill: "white",
    stroke: "#26245B",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 70.5254,
    width: 46.6524,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 73.4512,
    width: 43.7366,
    height: 1.95042,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 76.376,
    width: 9.71924,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1185 14.7406C12.1185 16.9875 10.3033 18.8082 8.06519 18.8082C5.82711 18.8082 4.01188 16.9875 4.01188 14.7406C4.01188 12.4936 5.82711 10.673 8.06519 10.673C10.3033 10.673 12.1185 12.4936 12.1185 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint0_linear_8510_10912)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8079 14.7406C21.8079 16.9875 19.9927 18.8082 17.7546 18.8082C15.5166 18.8082 13.7013 16.9875 13.7013 14.7406C13.7013 12.4936 15.5166 10.673 17.7546 10.673C19.9927 10.673 21.8079 12.4936 21.8079 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint1_linear_8510_10912)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4935 14.7406C31.4935 16.9875 29.6783 18.8082 27.4402 18.8082C25.2021 18.8082 23.3869 16.9875 23.3869 14.7406C23.3869 12.4936 25.2021 10.673 27.4402 10.673C29.6783 10.673 31.4935 12.4936 31.4935 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint2_linear_8510_10912)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.181 14.7406C41.181 16.9875 39.3658 18.8082 37.1277 18.8082C34.8896 18.8082 33.0744 16.9875 33.0744 14.7406C33.0744 12.4936 34.8896 10.673 37.1277 10.673C39.3658 10.673 41.181 12.4936 41.181 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint3_linear_8510_10912)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8685 14.7406C50.8685 16.9875 49.0533 18.8082 46.8152 18.8082C44.5771 18.8082 42.7619 16.9875 42.7619 14.7406C42.7619 12.4936 44.5771 10.673 46.8152 10.673C49.0533 10.673 50.8685 12.4936 50.8685 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint4_linear_8510_10912)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.69531,
    y: 21.1787,
    width: 47.6243,
    height: 47.7856,
    rx: 0.633439,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.96289,
    y: 3.33203,
    width: 20.0864,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.96289,
    y: 6.25879,
    width: 9.07129,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0398,
    cy: 70.0398,
    r: 21.0398,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.498 69.832L46.8311 72.165L51.4971 67.499M56.1631 68.8988C56.1631 73.5373 52.0803 77.2977 47.9976 81.4971C43.9148 77.2977 39.832 73.5373 39.832 68.8988C39.832 64.2603 43.4879 60.5 47.9976 60.5C52.5073 60.5 56.1631 64.2603 56.1631 68.8988Z",
    stroke: "white",
    strokeWidth: 2.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8510_10912",
    x: 0.166403,
    y: 0.374023,
    width: 57.7172,
    height: 88.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5836,
    dy: 3.16719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8510_10912"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8510_10912",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8510_10912",
    x1: 8.06519,
    y1: 10.5146,
    x2: 8.06519,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8510_10912",
    x1: 17.7546,
    y1: 10.5146,
    x2: 17.7546,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8510_10912",
    x1: 27.4402,
    y1: 10.5146,
    x2: 27.4402,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8510_10912",
    x1: 37.1277,
    y1: 10.5146,
    x2: 37.1277,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8510_10912",
    x1: 46.8152,
    y1: 10.5146,
    x2: 46.8152,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProximityCampaign);
export default __webpack_public_path__ + "static/media/proximityCampaign.4b5d31d9d30dc6aabaa11966bc3ee27a.svg";
export { ForwardRef as ReactComponent };